/**
 * Minicart Dynamic Update
 * Handles real-time updates when items are added/removed from cart
 */
(function($) {
  'use strict';

  var MinicartUpdate = {
    
    // Configuration
    config: {
      minicartSelector: '.enj-minicart-ajax',
      cartCountSelector: '.enj-cartcount',
      miniCartCounterSelector: '.mini-cart-counter .cart-counter',
      cartTotalSelector: '.total-price',
      removeProductSelector: '.remove-product',
      headerCartBadge: '.js-number-cart',
      moneyFormat: '',
      moneyFormatWithCurrency: ''
    },

    // Flag to prevent duplicate event handling
    isUpdating: false,
    updateTimeout: null,

    /**
     * Initialize the minicart update functionality
     */
    init: function() {
      this.bindEvents();
    },

    /**
     * Bind cart update events
     */
    bindEvents: function() {
      var self = this;
      
      // Listen to Shopify cart updates
      $(document).on('ajaxCart.afterCartLoad', function(evt, cart) {
        self.updateMinicart(cart);
      });

      // Atualiza conteúdo do minicart ao receber cart:updated (add/remove)
      $(document).on('cart:updated', function(evt, cart) {
        self.updateMinicart(cart);
        if (cart) {
          self._lastCartCount = cart.item_count;
        }
      });

      // Atualiza conteúdo do minicart após add to cart (sem abrir o drawer)
      $(document).on('cart:item-added', function() {
        setTimeout(function() {
          self.getCart(function(cart) {
            self.updateMinicart(cart);
          });
        }, 350);
      });

      // IMPORTANT: Do NOT handle remove clicks here
      // The ajax-cart.js already handles this
      // We just need to update the UI when the event is triggered

      // Update minicart when it's opened
      $(document).on('click', '.js-call-minicart', function() {
        self.updateMinicart();
      });

      // Initial load of minicart
      this.loadInitialCart();
    },

    /**
     * Load initial cart state
     */
    loadInitialCart: function() {
      var self = this;
      this.getCart(function(cart) {
        self._lastCartCount = cart.item_count;
        self.updateCartCount(cart.item_count);
        self.updateMinicart(cart);
      });
    },

    /**
     * Fetch cart data from Shopify
     */
    getCart: function(callback) {
      $.getJSON('/cart.js', function(cart) {
        if (typeof callback === 'function') {
          callback(cart);
        }
      });
    },

    /**
     * Update the entire minicart content with debounce
     */
    /**
     * Abre o cart drawer (mesma lógica do engo-scripts minicart)
     */
    openDrawer: function() {
      var $drawer = $('#cart-drawer');
      var $panel = $('.js-minicart');
      var $overlay = $('.bg-minicart');
      var $closeBtn = $('.cart-drawer__close, .close-mini-cart');
      if (!$panel.length || !$overlay.length) return;
      $panel.addClass('active');
      $overlay.addClass('active');
      $('body').addClass('cart-drawer-open');
      if ($drawer.length) {
        $drawer.attr('aria-hidden', 'false');
        setTimeout(function() {
          $closeBtn.first().focus();
        }, 150);
      }
    },

    updateMinicart: function(cart) {
      var self = this;

      if (this.updateTimeout) {
        clearTimeout(this.updateTimeout);
        this.updateTimeout = null;
      }

      var doUpdate = function(cartData) {
        if (self.isUpdating && !cartData) return;
        self.isUpdating = true;
        try {
          self.renderMinicart(cartData);
        } catch (err) {
          console.warn('Minicart render error:', err);
        } finally {
          self.isUpdating = false;
          if (window.FlorenzaMinicartLoading) {
            window.FlorenzaMinicartLoading.hide();
          }
        }
      };

      if (cart) {
        doUpdate(cart);
      } else {
        this.updateTimeout = setTimeout(function() {
          self.getCart(function(cartData) {
            doUpdate(cartData);
          });
        }, 50);
      }
    },

    /**
     * Render minicart HTML
     */
    renderMinicart: function(cart) {
      var self = this;
      var $container = $(this.config.minicartSelector);

      if (!$container.length) {
        return;
      }

      // Update cart count in header and minicart
      this.updateCartCount(cart.item_count);

      // Clear current content and render
      $container.empty();

      if (cart.item_count === 0) {
        $container.html(this.getEmptyCartHTML());
      } else {
        var html = this.getCartItemsHTML(cart);
        $container.html(html);
        if (window.FlorenzaMinicartFsb) {
          setTimeout(function () {
            window.FlorenzaMinicartFsb.refresh({ cartTotal: cart.total_price });
          }, 50);
        }
      }

      $('.remove-product').removeClass('is-removing');
      $container.removeClass('is-updating');
    },

    /**
     * Update cart count badge
     */
    updateCartCount: function(count) {
      var $cartCount = $(this.config.cartCountSelector);
      var $miniCartCounter = $(this.config.miniCartCounterSelector);
      var $headerBadge = $(this.config.headerCartBadge);

      $cartCount.html(count);
      $miniCartCounter.html(count);
      $headerBadge.html(count);
      if (count > 0) {
        $headerBadge.addClass('active');
      } else {
        $headerBadge.removeClass('active');
      }
    },

    /**
     * Get empty cart HTML
     */
    getEmptyCartHTML: function() {
      return `
        <div class="list_product_minicart empty">
          <div class="empty-product_minicart">
            <p class="mb-0">${window.minicart_translations?.empty || 'Sua sacola está vazia'}</p>
            <a href="/collections/all" class="to-cart">${window.minicart_translations?.shop_now || 'Ir para a loja'}</a>
          </div>
        </div>
      `;
    },

    /**
     * Get cart items HTML
     */
    getCartItemsHTML: function(cart) {
      var self = this;
      var itemsHTML = '';
      
      // Generate items HTML
      $.each(cart.items, function(index, item) {
        var imgUrl = item.image ? self.getImageUrl(item.image, 'small') : '//cdn.shopify.com/s/assets/no-image-50.png';
        var itemPrice = self.formatMoney(item.price);
        
        itemsHTML += `
          <cart-item class="minicart_item cart-drawer__item d-flex list-unstyled mb-0 px-0" data-line="${index + 1}" data-key="${item.key || ''}" data-variant-id="${item.variant_id}">
            <div class="thumb_img_cartmini cart-item__media">
              <a href="${item.url}" title="${self.escapeHtml(item.title)}" class="cart-item__link">
                <img class="cart-item__image" alt="${self.escapeHtml(item.title)}" src="${imgUrl}" loading="lazy" width="80" height="80">
              </a>
            </div>
            <div class="product-detail cart-item__details">
              <p class="product_name_mini cart-item__name">
                <a href="${item.url}">${self.escapeHtml(item.title)}</a>
              </p>
              <div class="product_info cart-item__info">
                <div class="product_quanity cart-item__quantity">
                  <div class="minicart-qty-control" data-line="${index + 1}">
                    <button type="button" class="minicart-qty-btn minicart-qty-minus" data-line="${index + 1}" aria-label="Diminuir quantidade">&#8722;</button>
                    <input type="number" class="minicart-qty-input" data-line="${index + 1}" value="${item.quantity}" min="0" aria-label="Quantidade">
                    <button type="button" class="minicart-qty-btn minicart-qty-plus" data-line="${index + 1}" aria-label="Aumentar quantidade">&#43;</button>
                  </div>
                </div>
                <div class="product_price cart-item__price">
                  <span class="price_sale">${itemPrice}</span>
                </div>
              </div>
            </div>
            <div class="produc_remove cart-item__remove">
              <a href="javascript:void(0)" class="remove-product" data-line="${index + 1}" data-variant-id="${item.variant_id}" aria-label="Remover item">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </a>
            </div>
          </cart-item>
        `;
      });

      // Build complete HTML structure
      var totalPrice = this.formatMoney(cart.total_price);
      var isRTL = $('body').hasClass('rtl');
      
      var html = `
        <div
          class="minicart-fsb minicart-fsb--pending"
          data-minicart-fsb
          data-cart-total="${cart.total_price}"
          data-customer-cep="${this.escapeHtml((document.querySelector('[data-minicart-customer-cep]') && document.querySelector('[data-minicart-customer-cep]').getAttribute('data-minicart-customer-cep')) || '')}"
          role="status"
          aria-live="polite"
        >
          <p class="minicart-fsb__hint" data-minicart-fsb-hint>Informe seu CEP abaixo para calcular o frete grátis</p>
          <div class="minicart-fsb__track" data-minicart-fsb-track hidden>
            <div class="minicart-fsb__fill" style="width: 0%;" data-minicart-fsb-fill></div>
            <div class="minicart-fsb__content">
              <span class="minicart-fsb__text" data-minicart-fsb-text></span>
            </div>
          </div>
        </div>
        <div class="prod">
          <cart-drawer-items class="product-cart cart-drawer-items">
            <form method="post" action="/cart" id="cart-drawer-form" class="cart-drawer-form" accept-charset="UTF-8">
              <input type="hidden" name="form_type" value="cart">
              <input type="hidden" name="utf8" value="✓">
              ${itemsHTML}
            </form>
          </cart-drawer-items>
        </div>
        <div class="minicart-frete-calc">
          <p class="minicart-frete-title">Calcule o Frete</p>
          <div class="minicart-frete-form">
            <input type="text" class="minicart-frete-cep" placeholder="Digite seu CEP" maxlength="9" inputmode="numeric" autocomplete="postal-code">
            <button type="button" class="minicart-frete-btn">CONSULTAR</button>
          </div>
          <div class="minicart-frete-results"></div>
        </div>
        <div class="sub-total">
          ${isRTL ? `
            <span class="total-title float-right">${window.minicart_translations?.total_price || 'Total:'}</span>
            <span class="total-price float-left">${totalPrice}</span>
          ` : `
            <span class="total-title float-left">${window.minicart_translations?.total_price || 'Total:'}</span>
            <span class="total-price float-right">${totalPrice}</span>
          `}
        </div>
        <div class="action-checkout">
          ${isRTL ? `
            <a href="/checkout" class="button-checkout">
              <span>${window.minicart_translations?.checkout || 'Finalizar compra'}</span>
            </a>
            <a href="/cart" class="button-viewcart">
              <span>${window.minicart_translations?.view_cart || 'Ver sacola'}</span>
            </a>
          ` : `
            <a href="/cart" class="button-viewcart">
              <span>${window.minicart_translations?.view_cart || 'Ver sacola'}</span>
            </a>
            <a href="/checkout" class="button-checkout">
              <span>${window.minicart_translations?.checkout || 'Finalizar compra'}</span>
            </a>
          `}
        </div>
      `;
      
      return html;
    },

    /**
     * Format money with Shopify format
     */
    formatMoney: function(cents) {
      var fmt = (typeof window !== 'undefined' && window.shop_money_format) ? window.shop_money_format : (this.config.moneyFormat || this.config.moneyFormatWithCurrency);
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, fmt);
      }
      var value = (cents / 100).toFixed(2);
      return (fmt || '').replace(/\{\{amount\}\}/g, value);
    },

    /**
     * Get product image URL with size
     */
    getImageUrl: function(url, size) {
      if (!url) return '';
      
      size = size || 'small';
      return url.replace(/(\.[^.]*)$/, "_" + size + "$1").replace('http:', '');
    },

    /**
     * Decode HTML entities (e.g. &amp; -> &) before re-escaping for display.
     */
    decodeHtmlEntities: function(text) {
      if (!text) return '';
      var textarea = document.createElement('textarea');
      textarea.innerHTML = text.toString();
      return textarea.value;
    },

    /**
     * Escape HTML to prevent XSS
     */
    escapeHtml: function(text) {
      if (!text) return '';
      text = this.decodeHtmlEntities(text);
      var map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      };
      return text.toString().replace(/[&<>"']/g, function(m) { return map[m]; });
    }
  };

  // Initialize when document is ready
  $(document).ready(function() {
    MinicartUpdate.init();
  });

  // Expose to global scope
  window.MinicartUpdate = MinicartUpdate;

})(jQuery);
